import script from "./Component-Technical-data.vue?vue&type=script&setup=true&lang=js"
export * from "./Component-Technical-data.vue?vue&type=script&setup=true&lang=js"

import "./Component-Technical-data.vue?vue&type=style&index=0&id=6e6bb7e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e6bb7e2"]])

export default __exports__